export enum ServiceHistoryTypeEnum {
  Unknown,
  None = 1,
  Full,
  FullFranchise,
  Partial,
  Yes // when the service history is available but type not specified
}
